<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по названию и описанию"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />

    <v-row dense>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.is_archived"
          label="В архиве?"
          :options="archivedOptions"
          :skeleton="skeleton"
          item-text="label"
          item-value="value"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  is_archived: null,
})

const ARCHIVED_OPTIONS = [
  { label: 'В архиве', value: true },
  { label: 'Не в архиве', value: false },
]

export default {
  name: 'PublicationsFilter',
  components: {
    BListFilter,
    BAutocompleteCommon,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    archivedOptions: ARCHIVED_OPTIONS,
  }),
}
</script>
